import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { ProjectLineItem } from "catchment-common/interfaces/project";

/**
 * Builds a nav item url only when both project and package are present.
 * Mirrors the repeated `project && contractorPackage ? builder() : ""` guard
 * used across the menu-item builders. Returns "" when either is missing so the
 * link renders as a no-op (same behaviour as before).
 */
export const safeUrl = (
  project: ProjectLineItem | undefined,
  contractorPackage: ContractorPackageLineItem | undefined,
  builder: () => string
): string => (project && contractorPackage ? builder() : "");
